// extracted by mini-css-extract-plugin
module.exports = {"container":"_025a50318d--container--54YkC","list":"_025a50318d--list--1cscI","list-inner":"_025a50318d--list-inner--1Bzq_"};